import React from 'react';
import {renderFragment} from '../helpers/react-helpers'

export default function reactLoader(page: string, props: Record<string, any>) {
    if(typeof Sentry !== 'undefined') {
        Sentry.setTag('react.page', page);
        Sentry.setContext('Page Props', props);
    }
    import(`../components/${page}`).then(Page => {
        renderFragment(<Page.default {...props}/>, '#react-root')
    });
}
